// extracted by mini-css-extract-plugin
module.exports =  {"container":"_6c97079b1b--container--PfiEY","icon":"_6c97079b1b--icon--aej3S","content":"_6c97079b1b--content--Bp0zC"};